import { AllNotificationsContentProps } from '@/utils/hooks/context/toast/types';

import NotificationsAnalytics from '@/components/composite/Notifications/Analytics';
import NotificationsCollaboration from '@/components/composite/Notifications/Collaboration';
import NotificationsContent from '@/components/composite/Notifications/Content';
import NotificationsConversations from '@/components/composite/Notifications/Conversations';
import DefaultCustomNotification from '@/components/composite/Notifications/Custom';
import NotificationsDashboard from '@/components/composite/Notifications/Dashboard';
// Components
import NotificationsReports from '@/components/composite/Notifications/Reports';
import NotificationsScheduler from '@/components/composite/Notifications/Scheduler';
import NotificationsSubscription from '@/components/composite/Notifications/Subscription';
import NotificationsUserRoles from '@/components/composite/Notifications/UsersRoles';

const NotificationsContainer = ({ notification }: AllNotificationsContentProps) => {
    const category = notification.category;
    switch (category) {
        case 'analytics':
            return <NotificationsAnalytics notification={notification} />;
        case 'collaboration':
            return <NotificationsCollaboration notification={notification} />;
        case 'content':
            return <NotificationsContent notification={notification} />;
        case 'conversations':
            return <NotificationsConversations notification={notification} />;
        case 'dashboard':
            return <NotificationsDashboard notification={notification} />;
        case 'reports':
            return <NotificationsReports notification={notification} />;
        case 'subscription':
            return <NotificationsSubscription notification={notification} />;
        case 'users_and_roles':
            return <NotificationsUserRoles notification={notification} />;
        case 'custom':
            return <DefaultCustomNotification notification={notification} />;
        case 'scheduler':
            return <NotificationsScheduler notification={notification} />;
        default:
            return null;
    }
};

export default NotificationsContainer;
